var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{ref:_vm.details.name,class:{ 'selected-border': _vm.selected },style:(_vm.style),on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.details.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }